import React from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'

const MobilePlanAdditionalText = (props) => {
    const toBold = ['auto-recharge', 'data rollover']
    const formatBold = item => {
        toBold.forEach(search => {
            item = item.replaceAll(search, `<span class="bold">${search}</span>`)
        })

        return globals.noWidows(item)
    }

    return props.content.map((item, key) => {
        return <p key={key} className='m-0 mb-1 font-small' dangerouslySetInnerHTML={{ __html: formatBold(item) }} />
    })
}

MobilePlanAdditionalText.propTypes = {
    content: PropTypes.array.isRequired
}

export default MobilePlanAdditionalText



// WEBPACK FOOTER //
// ./resources/js/components/MobilePlanAdditionalText.js